import React, { useState, useEffect } from "react";
import ShortenForm from "./components/ShortenForm";
import LinkList from "./components/LinkList";
import HomeStats from './components/HomeStats';
import LoginForm from "./components/LoginForm";
import RegisterForm from "./components/RegisterForm";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppAdmin from "./admin/AppAdmin";
import { jwtDecode } from "jwt-decode";
import {
  AppBar, Toolbar, Typography, Button, Box, Modal, Paper, Container, Stack
} from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import LoginIcon from '@mui/icons-material/Login';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PersonIcon from '@mui/icons-material/Person';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import UserLayout from "./pages/user";
import MainNavBar from './components/MainNavBar';
import RedirectPage from "./pages/RedirectPage"; // <-- Thêm dòng này

function MainContent({
  token,
  setToken,
  modalOpen,
  setModalOpen,
  isRegister,
  setIsRegister,
  onLogin,
  user,
  setUser
}) {
  const handleLogout = () => {
    setToken("");
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #6366f1 0%, #06b6d4 100%)",
        pb: 5
      }}
    >
      {/* MENU ĐIỀU HƯỚNG */}
      <MainNavBar />

      {/* Navbar chính */}
      <AppBar
        position="static"
        elevation={0}
        sx={{
          bgcolor: "transparent",
          boxShadow: "none",
          pt: 1,
          pb: 1.5
        }}
      >
        <Toolbar sx={{ maxWidth: 1280, mx: "auto", width: "100%", px: 2 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <LinkIcon sx={{ color: "#facc15", fontSize: 36, mr: 0.5 }} />
            <Typography
              variant="h5"
              fontWeight={900}
              letterSpacing={2}
              color="#fff"
              sx={{ textShadow: "0 2px 10px #0003" }}
            >
              visaothe<span style={{ color: "#facc15" }}>.ShortLink</span>
            </Typography>
          </Stack>
          <Box flex={1} />
          {!token ? (
            <>
              <Button
                startIcon={<LoginIcon />}
                sx={{
                  bgcolor: "#6366f1",
                  color: "#fff",
                  fontWeight: 700,
                  borderRadius: 999,
                  px: 3,
                  mr: 2,
                  textTransform: "none",
                  boxShadow: "0 2px 12px #6366f155"
                }}
                onClick={() => { setIsRegister(false); setModalOpen(true); }}
              >
                Đăng nhập
              </Button>
              <Button
                startIcon={<HowToRegIcon />}
                variant="outlined"
                sx={{
                  color: "#fff",
                  borderColor: "#fff",
                  fontWeight: 700,
                  borderRadius: 999,
                  px: 3,
                  textTransform: "none",
                  boxShadow: "0 2px 12px #fff2"
                }}
                onClick={() => { setIsRegister(true); setModalOpen(true); }}
              >
                Đăng ký
              </Button>
            </>
          ) : (
            <Stack direction="row" spacing={2} alignItems="center">
              <Button
                variant="contained"
                color={user?.role === 'admin' ? "warning" : "primary"}
                sx={{
                  fontWeight: 700,
                  borderRadius: 99,
                  px: 3,
                  textTransform: "none",
                  bgcolor: user?.role === 'admin' ? "#facc15" : "#6366f1",
                  color: user?.role === 'admin' ? "#333" : "#fff",
                  boxShadow: "0 2px 12px #fff2"
                }}
                href={user?.role === 'admin' ? "/teolucpro" : "/user"}
                startIcon={
                  user?.role === 'admin'
                    ? <AdminPanelSettingsIcon />
                    : <PersonIcon />
                }
              >
                {user?.role === 'admin' ? "Quản trị" : "Trang cá nhân"}
              </Button>
              <Button
                onClick={handleLogout}
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  borderRadius: 999,
                  px: 3,
                  textTransform: "none"
                }}
              >
                Đăng xuất
              </Button>
            </Stack>
          )}
        </Toolbar>
      </AppBar>
      {/* Nội dung chính */}
      <Container maxWidth="md" sx={{ mt: { xs: 4, md: 8 }, mb: 4 }}>
        <Paper
          elevation={6}
          sx={{
            borderRadius: 7,
            boxShadow: "0 12px 48px #60a5fa33",
            px: { xs: 2, sm: 6 },
            py: { xs: 3, sm: 7 },
            textAlign: "center"
          }}
        >
          <Typography
            variant="h3"
            fontWeight={900}
            sx={{
              color: "#6366f1",
              mb: 1,
              fontSize: { xs: 26, sm: 36 },
              textShadow: "0 2px 16px #6366f166"
            }}
          >
            Rút gọn link miễn phí & cực nhanh
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 4, fontSize: 18 }}>
            Nhanh – Đẹp – Không quảng cáo – Đầy đủ thống kê!
          </Typography>

          <ShortenForm token={token} />
          {token && <LinkList token={token} />}
        </Paper>
      </Container>
      <HomeStats />

      {/* Modal */}
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="modal-auth"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box>
          <Paper elevation={3} sx={{ p: 4, minWidth: 350, borderRadius: 5 }}>
            {!isRegister ? (
              <>
                <LoginForm onLogin={onLogin} />
              </>
            ) : (
              <>
                <RegisterForm onRegister={() => setIsRegister(false)} />
              </>
            )}
          </Paper>
        </Box>
      </Modal>

      <Box sx={{ textAlign: "center", color: "#fff", mt: 7, fontSize: 17, letterSpacing: 1, opacity: 0.92 }}>
        © {new Date().getFullYear()} visaothe.net – Powered by ShortLink
      </Box>
    </Box>
  );
}

export default function App() {
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [modalOpen, setModalOpen] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [role, setRole] = useState("");
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("user");
    return u ? JSON.parse(u) : null;
  });

  useEffect(() => {
    if (user && user.role) {
      setRole(user.role);
    } else if (token) {
      try {
        const payload = jwtDecode(token);
        setRole(payload.role || "");
      } catch {
        setRole("");
      }
    } else {
      setRole("");
    }
  }, [token, user]);

  const handleLogin = (tk, u) => {
    setToken(tk);
    setUser(u);
    localStorage.setItem("token", tk);
    localStorage.setItem("user", JSON.stringify(u));
    setModalOpen(false);
    if (u && u.role === "admin") {
      window.location.href = "/teolucpro";
    } else {
      window.location.href = "/user";
    }
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <MainContent
              token={token}
              setToken={setToken}
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              isRegister={isRegister}
              setIsRegister={setIsRegister}
              onLogin={handleLogin}
              user={user}
              setUser={setUser}
            />
          }
        />
        <Route
          path="/teolucpro/*"
          element={
            role === "admin" ? (
              <AppAdmin />
            ) : (
              <div style={{ padding: 50, textAlign: "center", fontWeight: 700, fontSize: 22 }}>
                Bạn không có quyền truy cập trang này.
              </div>
            )
          }
        />
        <Route
          path="/user/*"
          element={token ? <UserLayout /> : <Navigate to="/" replace />}
        />
        {/* Các route chuyển hướng sang admin */}
        <Route path="/links" element={<Navigate to="/teolucpro/links" replace />} />
        <Route path="/users" element={<Navigate to="/teolucpro/users" replace />} />
        <Route path="/stats" element={<Navigate to="/teolucpro/stats" replace />} />
        <Route path="/logs" element={<Navigate to="/teolucpro/logs" replace />} />
        <Route path="/notifications" element={<Navigate to="/teolucpro/notifications" replace />} />

        {/* Thêm route chuyển hướng đếm ngược */}
        <Route path="/redirect/:short_code" element={<RedirectPage />} />

        {/* Route 404 */}
        <Route path="*" element={
          <div style={{ padding: 50, textAlign: "center", fontWeight: 700, fontSize: 22 }}>
            404 Not Found
          </div>
        } />
      </Routes>
    </BrowserRouter>
  );
}
